// extracted by mini-css-extract-plugin
export default {"footer":"reassign_side_panel-module___footer___ffbc586e"};